import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class WebhookSubscriptionQueryCriteriaClass extends BaseCriteriaModel {
  //header, bl_webhook_subscription_hdr table
  guid?: Optional<string> = Optional.empty();
  topic_hdr_guid?: Optional<string> = Optional.empty();
  url?: Optional<string> = Optional.empty();
  auth_header_name?: Optional<string> = Optional.empty();
  auth_header_value?: Optional<string> = Optional.empty();
  created_date?: Optional<string> = Optional.empty();
  updated_date?: Optional<string> = Optional.empty();
}

export class WebhookSubscriptionCriteriaModelQuery {
  query = '';

  constructor(WebhookSubscriptionCriteriaModel: WebhookSubscriptionQueryCriteriaClass) {

    if (!WebhookSubscriptionCriteriaModel) {
      return;
    }

    this.query += WebhookSubscriptionCriteriaModel.guid.filter(x => x !== '').map(x => '&guid=' + x).orElse('');
    this.query += WebhookSubscriptionCriteriaModel.topic_hdr_guid.filter(x => x !== '').map(x => '&topic_hdr_guid=' + x).orElse('');
    this.query += WebhookSubscriptionCriteriaModel.url.filter(x => x !== '').map(x => '&url=' + x).orElse('');
    this.query += WebhookSubscriptionCriteriaModel.auth_header_name.filter(x => x !== '').map(x => '&auth_header_name=' + x).orElse('');
    this.query += WebhookSubscriptionCriteriaModel.auth_header_value.filter(x => x !== '').map(x => '&auth_header_value=' + x).orElse('');
    this.query += WebhookSubscriptionCriteriaModel.created_date.filter(x => x !== '').map(x => '&created_date=' + x).orElse('');
    this.query += WebhookSubscriptionCriteriaModel.updated_date.filter(x => x !== '').map(x => '&updated_date=' + x).orElse('');

    this.query += '&status=' + WebhookSubscriptionCriteriaModel.status;
    this.query += '&orderBy=' + WebhookSubscriptionCriteriaModel.orderBy;
    this.query += '&order=' + WebhookSubscriptionCriteriaModel.order;
    this.query += '&offset=' + WebhookSubscriptionCriteriaModel.offset + '&limit=' + WebhookSubscriptionCriteriaModel.limit;
  }
}
